import type { BaseNoticeProps } from './types';
import { getBaseNoticeToneClassName, resolveBaseAppearance } from './theme';
import { cn, hasRenderableNode } from './utils';

export function BaseNotice({
  tone,
  icon,
  title,
  description,
  actions,
  children,
  appearance,
  className,
  classNames,
  style,
  ...noticeProps
}: BaseNoticeProps) {
  const theme = resolveBaseAppearance(appearance);
  const resolvedDescription = children ?? description;

  return (
    <div
      {...noticeProps}
      className={cn(
        theme.slots.noticeBase,
        getBaseNoticeToneClassName(theme, tone),
        classNames?.root,
        className,
      )}
      style={{
        ...theme.styles.notice,
        ...style,
      }}
    >
      {hasRenderableNode(icon) ? (
        <div className={cn(theme.slots.noticeIcon, classNames?.icon)}>
          {icon}
        </div>
      ) : null}
      <div className="min-w-0 flex-1">
        {hasRenderableNode(title) ? (
          <div className={cn(theme.slots.noticeTitle, classNames?.title)}>
            {title}
          </div>
        ) : null}
        {hasRenderableNode(resolvedDescription) ? (
          <div
            className={cn(
              theme.slots.noticeDescription,
              classNames?.description,
            )}
          >
            {resolvedDescription}
          </div>
        ) : null}
        {hasRenderableNode(actions) ? (
          <div className={cn(theme.slots.noticeActions, classNames?.actions)}>
            {actions}
          </div>
        ) : null}
      </div>
    </div>
  );
}
